import {formBody} from "../utils/common";

export const postJSON = (url, params = {}) => {
    return fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            /*'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',*/
        },
        body: JSON.stringify(params)
    })
        .then(res => res.json())
        .then(jsonBody => {
            if ('error' in jsonBody) {
                 throw jsonBody;
            } else {
               return jsonBody
            }
        })
        .catch(error => {
            console.log('ERROR WHEN SEND REQUEST!', error);
            throw error;
        })
}

export const postData = (url, params = {}) => {

    return fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: {
            "Accept": 'application/json',
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        body: formBody(params)
    })
        .then(res => res.json())
        .then(jsonBody => {
            if ('error' in jsonBody) {
                 throw jsonBody;
            } else {
               return jsonBody
            }
        })
        .catch(error => {
            console.log("ERROR WHEN SEND REQUEST!", error);
            throw error;
        })
};


export const getData = (url) => {

    return fetch(url, {
        credentials: 'include',
        method: 'GET',
        headers: {
            "Accept": 'application/json',
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
    })
        .then(res => res.json())
        .then(jsonBody => {
            if ('error' in jsonBody) {
                throw jsonBody.error;
            } else {
                return jsonBody
            }
        })
        .catch(error => {
            throw error;
        });

};


export const postFormData = (url, formData) => {

    return fetch(url, {
        credentials: 'include',
        method: 'POST',
        processData: false,
        contentType: false,
        mimeType: "multipart/form-data",
        body: formData,
    })
        .then(response => response.json())
        .catch(error => {
            throw error;
        })
};


export const postXMLFormData = (url, formData, progressFunc) => {

    return new Promise((resolve, reject) => {
        let xhr = new XMLHttpRequest();
        xhr.open('POST', url);
        xhr.withCredentials = true;
        xhr.upload.onprogress = progressFunc;
        xhr.onload = function () {
            if (xhr.readyState === 4 && xhr.status === 200) {
                let data = JSON.parse(xhr.response);
                resolve(data);
                console.log("ok:", data);
            } else {
                let err = JSON.parse(xhr.response);
                reject(err);
                console.log("fail:", err);
            }
        };
        xhr.onerror = function () {
            reject(xhr);
            reject(xhr);
            console.log("fail", xhr);
        };
        xhr.open("POST", url, true);
        xhr.send(formData);
    });
};



// WEBPACK FOOTER //
// src/fetch/index.jsx